import { render } from "./Home_bak.vue?vue&type=template&id=9dd1bd88&scoped=true"
import script from "./Home_bak.vue?vue&type=script&lang=js"
export * from "./Home_bak.vue?vue&type=script&lang=js"

import "./Home_bak.vue?vue&type=style&index=0&id=9dd1bd88&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dd1bd88"]])

export default __exports__